import { isPlainObject } from 'lodash';
import ClientError from './ClientError';

const AUTH_RETRY_COUNT = 1;

export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function canTransformToJSON(value) {
  return value != null && (isPlainObject(value) || Array.isArray(value) || typeof value.toJSON === 'function');
}

export async function setAuthHeader(request, { auth }) {
  let token;

  try {
    token = await auth.getToken();
  } catch (error) {}

  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`);
  }

  return request;
}

export function handleError(failureCount, error, { history, queryClient }) {
  if (isAuthError(error) && failureCount > AUTH_RETRY_COUNT) {
    history.push('/login');
    queryClient.clear();
  }
}

export function shouldRetry(failureCount, error, { auth }) {
  if (isAuthError(error) && failureCount <= AUTH_RETRY_COUNT) {
    auth.renewSession();

    return true;
  }

  return false;
}

function isAuthError(error) {
  return error instanceof ClientError && error.response.status === 420;
}
